import { isBrandKey, type BrandKey } from './types';

export interface BrandKeyInput {
  override?: string | null;
  envBrand?: string;
  appType?: string;
  switcherEnabled: boolean;
}

export function resolveBrandKey(input: BrandKeyInput): BrandKey {
  if (input.switcherEnabled && isBrandKey(input.override)) return input.override;
  if (isBrandKey(input.envBrand)) return input.envBrand;
  return input.appType === 'HRIQ' ? 'recruitingiq' : 'lead';
}
